function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.00084 16.36V14.6155C1.0014 13.8425 1.25425 13.0915 1.71967 12.4806C2.18509 11.8696 2.83673 11.4332 3.57227 11.24",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7 1C6.26442 1.19405 5.61245 1.63484 5.14687 2.25286C4.68128 2.87088 4.42857 3.63098 4.42857 4.41333C4.42857 5.19569 4.68128 5.95579 5.14687 6.57381C5.61245 7.19183 6.26442 7.63261 7 7.82667",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M19.8569 16.36V14.6533C19.8569 13.7481 19.4956 12.8799 18.8527 12.2397C18.2097 11.5996 17.3376 11.24 16.4283 11.24H9.57115C8.66184 11.24 7.78977 11.5996 7.14678 12.2397C6.5038 12.8799 6.14258 13.7481 6.14258 14.6533V16.36",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M12.9989 7.82667C14.8924 7.82667 16.4275 6.29846 16.4275 4.41333C16.4275 2.5282 14.8924 1 12.9989 1C11.1053 1 9.57031 2.5282 9.57031 4.41333C9.57031 6.29846 11.1053 7.82667 12.9989 7.82667Z",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M24.9992 16.36V14.6533C24.9986 13.8971 24.7458 13.1624 24.2803 12.5646C23.8149 11.9669 23.1633 11.54 22.4277 11.3509",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M19 1.11093C19.7375 1.29892 20.3912 1.72593 20.858 2.32464C21.3248 2.92334 21.5782 3.65969 21.5782 4.4176C21.5782 5.1755 21.3248 5.91185 20.858 6.51056C20.3912 7.10926 19.7375 7.53627 19 7.72426",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgSession = function SvgSession(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 18,
    viewBox: "0 0 26 18",
    stroke: "#18A0FB",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSession, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/session.b9c6848e.svg";
export { ForwardRef as ReactComponent };